import FontFaceObserver from 'fontfaceobserver';

const fontFamilies = {
  atlasGrotesk: 'Atlas Grotesk',
  portraitQ: 'Portrait Q'
};

export function fontsLoaded(cb) {
  const observers = Object.values(fontFamilies).map((family) =>
    new FontFaceObserver(family).load()
  );
  Promise.all(observers).then(cb);
}
